import { IAjaxConfig } from '../helpers';
/**
 *  订单 API 地址
 *  @swagger http://bpportalordersit.earth.xpaas.lenovo.com/swagger-ui/index.html#/%E5%A4%96%E9%83%A8%E8%AE%A2%E5%8D%95/
 */
export class EnumApiThirdOrders {
  /**
   * @dec 订单列表
   */
  readonly third_orders_list: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/v1/third/order/wapList',
    method: 'post',
  };

  /**
   * @dec 退货订单列表
   */
  readonly third_refund_orders_list: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/v1/third/orderRefund/wapList',
    method: 'post',
  };

  /**
   * @dec 订单详情-获取商品详情 状态1和5除外的其他
   */
  readonly third_refund_orders_details: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/v1/third/orderRefund/detail',
    method: 'post',
  };

  /**
   * @dec 订单详情-获取商品详情 状态1和5除外的其他
   */
  readonly third_orders_details: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order//v1/third/order/detail',
    method: 'post',
  };

  /**
   * @dec 订单：提交付款信息
   */
  readonly third_order_submitpayinfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/bp-order-payment/submit',
    loading: true,
    method: 'post',
  };

  /**
   * @dec 订单：获取付款信息
   */
  readonly third_order_getpayinfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/bp-order-payment/{orderNumber}',
    loading: true,
  };

  /**
   * @dec 订单：获取收款信息
   */
  readonly third_order_getcollectioninfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/provider/getPaymentInfo?code={code}',
    loading: true,
  };

  /**
   * @dec 上传支付凭证图片
   */
  readonly third_order_pay_upload_img: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/file/upload-file?type=1',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 订单详情：订单通过
   */
  readonly third_order_adopt: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerorder/order/adoptOrder',
    method: 'post',
  };

  /**
   * @dec 我的订单 查看物流信息接口
   */
  readonly third_order_getstockinfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/v1/third/delivery/list',
    method: 'post',
  };

  /**
   * @dec 下单成功页 获取当前订单状态信息
   */
  readonly third_order_getSingleOrderPollingResult: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/createorder/querySingleOrderPollingResult',
    method: 'post',
  };

  /**
   * @dec 我的订单 获取当前账号下处理中的订单状态信息
   */
  readonly third_order_getAllOrderPollingResult: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/createorder/queryAllOrderPollingResult',
  };

  /**
   * @dec 我的订单 删除失败订单提示
   */
  readonly third_order_clearOrderFailed: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/createorder/clearOrderFailed',
    method: 'post',
  };

  /**
   * @dec 获取门店列表
   */
  readonly third_order_getShopList: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/v1/bp-order-api/t2/store-list',
    cache: true,
  };
}
